import React from 'react';
import { ProgramasSlider } from '../ProgramasSlider/ProgramasSlider';
import './Areas.css';
import { areas } from '../../utils/constantes';

const Areas = ({ loading, programas }) => {
  const fillContent = () => {
    let key = 0;
    return (
      <>
        {areas.map((area) => (
          <ProgramasSlider
            key={key++}
            area={area}
            programas={programas}
            loading={loading}
          />
        ))}
      </>
    );
  };

  return fillContent();
};

export default Areas;
